// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications_server__9SiRb {
  width: 100%;
  margin-bottom: 10px;
  margin-bottom: 50px; }
  .notifications_server__header__Fi2gV {
    display: flex;
    justify-content: space-between; }
    .notifications_server__header__Fi2gV h2 {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 150%;
      margin-bottom: 6px; }
  .notifications_server__create__\\+J0b2 {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 10px; }
  .notifications_server__status__PrQ38 {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 10px; }
    .notifications_server__status_type__Yn9JR {
      color: #666666;
      margin-right: 5px; }

.notifications_emails__s4Laa {
  width: 100%; }
  .notifications_emails__container__s\\+Kd\\+ {
    margin-top: 20px;
    background: #ffffff;
    box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);
    border-radius: 4px;
    padding: 10px; }
  .notifications_emails__header__DSiX- {
    display: flex;
    flex-direction: row;
    justify-content: space-between; }
    .notifications_emails__header__DSiX- h3 {
      margin-bottom: 6px; }
    .notifications_emails__header_add__JNMIh {
      color: #fe6100;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      cursor: pointer;
      transition: all 0.4s; }
      .notifications_emails__header_add__JNMIh:hover {
        transform: scale(1.1); }
  .notifications_emails__description__MTIxb {
    margin-bottom: 20px; }
  .notifications_emails__list_div__d5vpQ {
    width: 460px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative; }
    .notifications_emails__list_div__d5vpQ .notifications_trash__\\+vfZx {
      color: #666666;
      cursor: pointer; }
      .notifications_emails__list_div__d5vpQ .notifications_trash__\\+vfZx:hover {
        color: #212121; }
    .notifications_emails__list_div__d5vpQ .notifications_checkmark__F8LX0 {
      position: absolute;
      right: 35px;
      color: green; }
    .notifications_emails__list_div__d5vpQ input {
      width: calc(100% - 30px);
      padding: 8px 16px;
      border: 1px solid #9e9e9e;
      border-radius: 4px; }
      .notifications_emails__list_div__d5vpQ input:focus {
        border-color: #212121;
        outline: none; }
`, "",{"version":3,"sources":["webpack://./src/pages/notificationEmail/notifications.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB,EAAA;EACnB;IACE,aAAa;IACb,8BAA8B,EAAA;IAF/B;MAIG,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,kBAAkB,EAAA;EAGtB;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB,EAAA;EAErB;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB,EAAA;IACnB;MACE,cAAc;MACd,iBAAiB,EAAA;;AAIvB;EACE,WAAW,EAAA;EACX;IACE,gBAAgB;IAChB,mBAAmB;IACnB,+CAA+C;IAC/C,kBAAkB;IAClB,aAAa,EAAA;EAEf;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAA;IAH/B;MAKG,kBAAkB,EAAA;IAEpB;MACE,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,eAAe;MACf,oBAAoB,EAAA;MANrB;QAQG,qBAAqB,EAAA;EAI3B;IACE,mBAAmB,EAAA;EAGnB;IACE,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB,EAAA;IANnB;MAQG,cAAc;MACd,eAAe,EAAA;MATlB;QAWK,cAAc,EAAA;IAXnB;MAeG,kBAAkB;MAClB,WAAW;MACX,YAAY,EAAA;IAjBf;MAoBG,wBAAwB;MACxB,iBAAiB;MACjB,yBAAyB;MACzB,kBAAkB,EAAA;MAvBrB;QAyBK,qBAAqB;QACrB,aAAa,EAAA","sourcesContent":[".server {\n  width: 100%;\n  margin-bottom: 10px;\n  margin-bottom: 50px;\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    h2 {\n      font-style: normal;\n      font-weight: 600;\n      font-size: 24px;\n      line-height: 150%;\n      margin-bottom: 6px;\n    }\n  }\n  &__create {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 10px;\n  }\n  &__status {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 10px;\n    &_type {\n      color: #666666;\n      margin-right: 5px;\n    }\n  }\n}\n.emails {\n  width: 100%;\n  &__container {\n    margin-top: 20px;\n    background: #ffffff;\n    box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);\n    border-radius: 4px;\n    padding: 10px;\n  }\n  &__header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    h3{\n      margin-bottom: 6px;\n    }\n    &_add {\n      color: #fe6100;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 24px;\n      cursor: pointer;\n      transition: all 0.4s;\n      &:hover {\n        transform: scale(1.1);\n      }\n    }\n  }\n  &__description {\n    margin-bottom: 20px;\n  }\n  &__list {\n    &_div {\n      width: 460px;\n      margin-bottom: 30px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      position: relative;\n      .trash {\n        color: #666666;\n        cursor: pointer;\n        &:hover {\n          color: #212121;\n        }\n      }\n      .checkmark {\n        position: absolute;\n        right: 35px;\n        color: green;\n      }\n      input {\n        width: calc(100% - 30px);\n        padding: 8px 16px;\n        border: 1px solid #9e9e9e;\n        border-radius: 4px;\n        &:focus {\n          border-color: #212121;\n          outline: none;\n        }\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"server": `notifications_server__9SiRb`,
	"server__header": `notifications_server__header__Fi2gV`,
	"server__create": `notifications_server__create__+J0b2`,
	"server__status": `notifications_server__status__PrQ38`,
	"server__status_type": `notifications_server__status_type__Yn9JR`,
	"emails": `notifications_emails__s4Laa`,
	"emails__container": `notifications_emails__container__s+Kd+`,
	"emails__header": `notifications_emails__header__DSiX-`,
	"emails__header_add": `notifications_emails__header_add__JNMIh`,
	"emails__description": `notifications_emails__description__MTIxb`,
	"emails__list_div": `notifications_emails__list_div__d5vpQ`,
	"trash": `notifications_trash__+vfZx`,
	"checkmark": `notifications_checkmark__F8LX0`
};
export default ___CSS_LOADER_EXPORT___;
